
export const setState = (key, value) => {
  try {
    const serializedState = JSON.stringify(value);
    localStorage.setItem(key, serializedState);
  } catch (err) {
    return undefined;
  }
};

export const getState = (key) => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {}
};

export const STORAGE_KEYS = {
  HOT_SESSION_DATA: "hot_auth_session-data",
  KB_ACTIVE_TENANT: "kb_active_tenant"
}

const PRESERVED_KEYS = [
  STORAGE_KEYS.HOT_SESSION_DATA,
  STORAGE_KEYS.KB_ACTIVE_TENANT
];

export const clearLocalStoragePreserving = () => {
  const preserved = PRESERVED_KEYS.reduce((acc, key) => {
    const value = localStorage.getItem(key);
    if (value !== null) acc[key] = value;
    return acc;
  }, {});
  localStorage.clear();
  Object.entries(preserved).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};